'use strict';

import $ from 'jquery';
// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

function J3WTheme() {

    var self = this;

    self.smWidth = 575;
    self.mdWidth = 998;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");
    self.$swiperGallery = $("#js-swiper-gallery");
    self.$swiperGalleryThumbs = $("#js-swiper-gallery-thumbs");
    self.galleryTop = undefined;
    self.galleryThumbs = undefined;
    self.ajax = false;

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        //self.cloneMainMenu();
        self.fancybox();
        self.swiperHeroInit();
        self.swiperGalleryInit();
/*
        if( self.$window.width() > self.smWidth ){
            self.swiperGalleryInit();
        }
        else {
            self.swiperGalleryDestroy();
        }
*/
        self.ajaxCF7();
        self.popupInit();

    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("click", function () {
            self.mobileMenu();
        });

        $("#js-office-tabs").on("click", "a", function(e) {

            var $this = $(this);

            $this.closest("ul").find("a").removeClass("active");
            self.ajaxOfficeTable( $this.data("floor") );
            $this.addClass("active");

            e.preventDefault();
        } );

        $(".js-cowork-plan").on("click", function(e) {
            // Add title and content to popup
            var title = $(this).closest(".c-item").find(".js-cowork-popup-title").text();
            var content = $(this).closest(".c-item").find(".js-cowork-popup-content").html();
            $("#js-cowork-popup-title").text( title );
            $("#js-cowork-popup-content").html( content );
            // Open popup
            $("#js-cowork-popup").addClass("cowork-popup--open");
            // Set plan
            $("#js-cowork-popup-choose").data("slug", $(this).data("slug") );
            e.preventDefault();
        });

        $("#js-cowork-popup-choose").on("click", function(){
            // Scroll
            var element = document.querySelector("#vybrat-cowork-plan");
            element.scrollIntoView({ behavior: "smooth", block: "end"});
            // Choose option
            $("#coworkplan option[data-slug='" + $(this).data("slug") + "']").prop("selected", true);
            // Close popup
            self.closeCoworkPopup();
        });

        $(".js-cowork-popup-close").on("click", function(){
            self.closeCoworkPopup();
        });

        $("#js-popup-form-btn").on("click", function( e ) {
            $("#js-event-popup").addClass("event-popup--open");
            e.preventDefault();
        } );

        $(".js-event-popup-close").on("click", function(){
            self.closeEventPopup();
        });

        self.$document.keydown(function (e) {
            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                self.closeCoworkPopup();
                self.closeEventPopup();
            }
        });

        $(".js-qr-nav").on("click", "a", function(e) {

            var $this = $(this);

            $this.closest(".js-qr-nav").find("a").removeClass("active");
            $this.addClass("active");

            $(".js-qr-plan").removeClass("qr-plan--show");

            var id = $this.data("id");
            $('#' + id).addClass("qr-plan--show");

            e.preventDefault();
        });

    },

    closeCoworkPopup: function(){
        $("#js-cowork-popup").removeClass("cowork-popup--open");
    },

    closeEventPopup: function(){
        $("#js-event-popup").removeClass("event-popup--open");
    },

    popupInit: function() {

        var self = this;

        //if ( Cookies.get("tt-popup") === undefined || Cookies.get("tt-popup") < 1 ) {
        //    $(".popup").addClass("popup--open");
        //}

        $(".js-open-popup").on("click", function(e) {
            self.$body.addClass("popup-is-open");
            //$(this).closest("div").find(".popup").addClass("popup--open");
            $(".popup").addClass("popup--open");
            e.preventDefault();
        });

        $(".js-popup-close").on("click", function(e){
            self.closePopup();
            e.preventDefault();
        });

        self.$document.keydown(function (e) {
            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                self.$body.removeClass("popup-is-open");
                $(".popup").removeClass("popup--open");
            }
        });
    },

    closePopup: function(){
        var self = this;
        self.$body.removeClass("popup-is-open");
        $(".popup").removeClass("popup--open");
        //Cookies.set("tt-popup", 1);
    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("mobile-menu--open") ){
            self.$mobileMenu.removeClass("mobile-menu--open");
            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$mobileMenu.addClass("mobile-menu--open");
            t = setTimeout( function(){
                $hamburger.addClass("is-active");
            }, 200 );
        }

    },

    cloneMainMenu: function(){

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        //if( self.$document.scrollTop() > self.$header.outerHeight() ) {
        if( self.$document.scrollTop() > 0 ) {
            self.$body.addClass('js-scrolling');
        }
        else {
            self.$body.removeClass('js-scrolling');
        }
/*
        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }
*/
    },

    fancybox: function() {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });

        $('[data-fancybox="floor-plan"]').fancybox({
            loop: false,
            slideClass: "floor-plan-modal",
            buttons: [
                "zoom",
                "fullScreen",
                "close"
            ]
        });
    },

    swiperHeroInit: function() {

        var self = this;

        //if ( $("#js-swiper-hero").length < 2 ) { return false; }

        self.swiperHero = new Swiper('#js-swiper-hero', {
            loop: false,
            speed: 900,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            lazyLoading: true,
            lazy: {
                loadPrevNext: true,
            },
            /*
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
        });
    },

    swiperGalleryTopInit: function (){

        var self = this;

        /* gallery  */
        self.galleryTop = new Swiper( self.$swiperGallery[0], {
            slidesPerView: "auto",
            spaceBetween: 20,
            grabCursor: false,
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            navigation: {
                nextEl: ".swiper-btn-next",
                prevEl: ".swiper-btn-prev"
            },
            speed: 300,
            loop: true,
            loopedSlides: 4,
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            on: {
                "slideChange": function( e ) {
                    $("#js-swiper-caption").text( $(e.slides[ e.activeIndex ]).data("caption") );
                }
            }
        });

    },

    swiperGalleryThumbsInit: function (){

        var self = this;

        /* thumbs */
        self.galleryThumbs = new Swiper( self.$swiperGalleryThumbs[0], {
            spaceBetween: 16,
            centeredSlides: true,
            slidesPerView: "auto",
            touchRatio: 0.4,
            slideToClickedSlide: true,
            loop: true,
            loopedSlides: 4,
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 6
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false
            }
        });

    },

    swiperGalleryInit: function(){

        var self = this;

        // Zobrazime kontejner pro horni galerii
        self.$swiperGallery.show();

        // Nastartujeme galerii i s thumbnailama
        self.swiperGalleryTopInit();
        //self.swiperGalleryThumbsInit();

        // Nastavime kontrolery
        /*if ( self.$swiperGallery.length > 0 ) {
            self.galleryTop.controller.control = self.galleryThumbs;
            self.galleryThumbs.controller.control = self.galleryTop;
        }*/

        // Pokud mydlime oknem a mame zobrazeny lightbox
        // zavreme ho - mozna bysme ho mohli nechat - nevim
        //if( self.photoSwipe ){
        //    self.photoSwipe.close();
        //}

        // Odstranime class
        // kterou detekujeme, jestli se ma pouzit ten lightbox (photoswipe)
        self.$body.removeClass("zoom");

    },

    swiperGalleryDestroy: function(){

        var self = this;

        // zabi tu velkou
        if ( self.galleryTop ) {
            self.galleryTop.destroy();
        }

        // unset controller
        if( self.galleryThumbs ){
            self.galleryThumbs.controller.control = false;
        }

        // Skryjeme velky nahledy
        //self.$swiperGallery.hide();
        // Nechame jen thumbnaily
        //self.swiperGalleryThumbsInit();

        // Pridame class
        // kterou detekujeme, jestli se ma pouzit ten lightbox (photoswipe)
        self.$body.addClass("zoom");

    },

    ajaxOfficeTable: function( floor ) {

        var self = this;

        // pokud ajax bezi, stopnem to a pockame na vysledek
        if( self.ajax || floor === "" ) {
            return false;
        }
        self.ajax = true;

        // Container
        var $content = $("#js-office-content");

        // Zobrazime loader
        $content.addClass("loading");

        $.ajax({
            url: ajaxCore.ajax_url,
            method: "POST",
            //cache: false,
            data: {
                action: 'j3w_get_office_table',
                floor: floor
            }
        })
        .done( function( data ) {
            $content.html( data );
            $content.removeClass("loading");
            lazyLoadInstance.update();
            self.ajax = false;
        })
        .fail( function( jqXHR, textStatus ) {
            console.log( 'SITg: AJAX error - ajaxGetOfficeTable() - ' + textStatus );
            self.ajax = false;
        });

    },

    ajaxCF7: function() {

        var self = this;

        var $wpcf7 = $( ".wpcf7" ),
            post_id = $("#js-popup-form-btn").data("id");

        // Tohle je krapet na pikacu - az nekdo zmeni tridu body bude zle :)
        if ( $wpcf7.length > 0 && self.$body.hasClass("page--event") ) {
            $wpcf7[0].addEventListener( "wpcf7submit", function( event ) {
                if ( event.detail.status === 'validation_failed' ) {
                    return false;
                }
                // Ajax calling
                self.ajaxCF7ThankYouContent( post_id );
            }, false );
        }

    },

    ajaxCF7ThankYouContent: function( post_id ) {

        var self = this;

        // pokud ajax bezi, stopnem to a pockame na vysledek
        if ( self.ajax ) {
            return false;
        }
        self.ajax = true;

        // Container
        var $content = $("#js-event-popup-content");

        // Zobrazime loader
        $content.addClass("loading");

        $.ajax({
            url: ajaxCore.ajax_url,
            method: "POST",
            //cache: false,
            data: {
                action: 'j3w_get_cf7_thank_you',
                post_id: post_id
            }
        })
        .done( function( data ) {
            $content.html( data );
            $content.removeClass("loading");
            self.ajax = false;
        })
        .fail( function( jqXHR, textStatus ) {
            console.log( 'SITg: AJAX error - ajaxCF7ThankYouContent() - ' + textStatus );
            self.ajax = false;
        });
    }

};

$(document).ready(function () {
    new J3WTheme();
});
